export default {
  // Nav
  "brand": "USFansLink",
  "nav.home": "Accueil",
  "nav.categories": "Catégories",
  "nav.guides": "Guides",
  "nav.faq": "FAQ",
  "nav.cta": "Voir le tableau",
  "nav.shoppingGuide": "Guide d'achat",

  // Hero
  "hero.badge": "Mis à jour pour 2026",
  "hero.title": "USFans Spreadsheet — trouvailles, QC, W2C et guides d'achat",
  "hero.subtitle": "Un seul endroit organisé pour explorer les produits, catégories, infos QC, liens W2C, guides d'expédition et conseils d'achat honnêtes avant de commander.",
  "hero.search": "Recherchez catégories, QC, W2C, expédition ou avis...",
  "hero.cta1": "USFans Spreadsheet",
  "hero.cta2": "Acheter maintenant",

  // Trust
  "trust.1": "Ressources à jour",
  "trust.2": "Informations indépendantes",
  "trust.3": "Guides pour débutants",

  // Categories
  "categories.badge": "Catégories de produits",
  "categories.title": "Parcourir les catégories de produits",
  "categories.subtitle": "Allez directement à la catégorie dont vous avez besoin sur le site principal.",
  "categories.dropdownLabel": "Choisir une catégorie",
  "categories.dropdownPlaceholder": "Sélectionnez une catégorie à explorer",
  "categories.empty": "Aucune catégorie ne correspond à votre recherche.",
  "categories.visit": "Voir la catégorie",

  // Category names
  "cat.shoes": "Chaussures",
  "cat.hoodies": "Hoodies / Sweats",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Vestes",
  "cat.pants": "Pantalons / Shorts",
  "cat.headwear": "Couvre-chefs",
  "cat.sets": "Ensembles",
  "cat.underwear": "Sous-vêtements / Caleçons",
  "cat.jersey": "Maillot",
  "cat.accessories": "Accessoires",
  "cat.bags": "Sacs",
  "cat.belts": "Ceintures",
  "cat.perfumes": "Parfums",
  "cat.other": "Autres articles",

  // What Is
  "whatis.title": "Qu'est-ce que le USFans Spreadsheet ?",
  "whatis.p1": "Le USFans Spreadsheet est une ressource organisée pour découvrir des produits, des liens produits, des infos QC et des ressources d'achat. Au lieu de chercher des liens éparpillés, un tableau bien structuré facilite l'exploration des produits, des catégories et des guides utiles en un seul endroit.",
  "whatis.p2": "Que vous cherchiez des chaussures, des hoodies, des maillots ou des accessoires, le tableau vous aide à passer d'une idée de produit à un lien vérifié et à une liste claire de ce qu'il faut vérifier avant de passer commande.",
  "whatis.cta": "Explorer le tableau",

  // Features
  "features.title": "Tout ce dont vous avez besoin avant d'acheter",
  "features.subtitle": "Des ressources pratiques pour rechercher, comparer et commander avec plus de confiance.",
  "feature.1.title": "USFans Spreadsheet",
  "feature.1.desc": "Explorez des ressources produits organisées et des liens de catégories en un seul endroit.",
  "feature.2.title": "Guide QC",
  "feature.2.desc": "Apprenez quoi vérifier et comment lire les photos de contrôle qualité avant de commander.",
  "feature.3.title": "Liens W2C",
  "feature.3.desc": "Comprenez les liens produits et les ressources W2C pour trouver ce que vous voulez.",
  "feature.4.title": "Coût d'expédition",
  "feature.4.desc": "Découvrez ce qui influence votre coût d'expédition final et comment planifier votre budget.",
  "feature.5.title": "Avis USFans",
  "feature.5.desc": "Comprenez le service, son fonctionnement et ses limites avant de l'utiliser.",
  "feature.6.title": "Sécurité USFans",
  "feature.6.desc": "Apprenez à réduire les risques en ligne courants et à acheter plus prudemment.",

  // Article CTA
  "articleCta.title": "Lire le guide complet",
  "articleCta.subtitle": "Nouveau sur le USFans Spreadsheet ? Commencez par notre guide pour débutants pour comprendre comment tout fonctionne.",
  "articleCta.button": "Lire le guide du USFans Spreadsheet",
  "articleCta.note": "Guides • Avis • Conseils de sécurité",

  // FAQ
  "faq.title": "Questions fréquentes",
  "faq.subtitle": "Des réponses rapides aux questions les plus courantes sur le USFans Spreadsheet.",
  "faq.1.q": "Qu'est-ce que le USFans Spreadsheet ?",
  "faq.1.a": "C'est une collection organisée de liens produits, de catégories, d'infos QC et de ressources d'achat qui vous aide à découvrir et à étudier des produits avant de commander.",
  "faq.2.q": "Comment fonctionne USFans ?",
  "faq.2.a": "USFans agit comme un service d'achat et de réexpédition. Vous trouvez un lien produit, vous commandez via le service, et il vous aide pour l'achat, les contrôles QC et l'expédition à votre adresse.",
  "faq.3.q": "USFans est-il légitime ?",
  "faq.3.a": "USFans est un service d'achat très discuté, mais vous devez toujours faire vos propres recherches, lire les retours récents de la communauté et vérifier les détails du vendeur et du paiement avant de commander.",
  "faq.4.q": "USFans est-il sûr ?",
  "faq.4.a": "Aucun achat en ligne n'est totalement sans risque. Réduisez le risque en vérifiant les avis vendeur, en confirmant les photos QC et en utilisant des moyens de paiement sécurisés.",
  "faq.5.q": "Combien coûte l'expédition USFans ?",
  "faq.5.a": "Le coût d'expédition dépend du poids, des dimensions, de la destination et de la méthode choisie. La consolidation peut aider à réduire le coût total.",
  "faq.6.q": "Qu'est-ce qu'un entrepôt USFans ?",
  "faq.6.a": "L'entrepôt stocke vos articles après l'achat, où les photos QC sont prises et les colis consolidés avant l'expédition internationale.",
  "faq.7.q": "Où trouver les liens W2C USFans ?",
  "faq.7.a": "Les liens W2C sont généralement partagés dans le tableau ou les ressources de la communauté. Vérifiez toujours un lien avant de l'utiliser.",
  "faq.8.q": "Y a-t-il des coupons USFans ?",
  "faq.8.a": "Les promotions et remises peuvent changer souvent. Consultez le site principal pour les offres actuelles et vérifiez tout coupon avant de l'utiliser.",

  // Guides section
  "guides.badge": "Guides et articles",
  "guides.title": "Guides et articles USFans",
  "guides.subtitle": "Des guides originaux et approfondis sur les avis, la livraison, le QC, le W2C, la sécurité et plus.",
  "guides.readMore": "Lire l'article",

  // Final CTA
  "final.title": "Prêt à explorer le USFans Spreadsheet ?",
  "final.subtitle": "Parcourez les catégories de produits, trouvez des ressources QC et W2C et commandez avec un plan plus clair.",
  "final.button": "Explorer le USFans Spreadsheet",

  // Footer
  "footer.tagline": "Votre centre de ressources indépendant pour le USFans Spreadsheet — trouvailles, QC, W2C, expédition et guides d'achat.",
  "footer.disclaimer": "USFansLink est une ressource informative indépendante. Sauf indication contraire, il n'est pas affilié, approuvé ni exploité par USFans.",
  "footer.explore": "Explorer",
  "footer.resources": "Ressources",
  "footer.legal": "Légal",
  "footer.home": "Accueil",
  "footer.categories": "Catégories",
  "footer.guide": "Guide du USFans Spreadsheet",
  "footer.faq": "FAQ",
  "footer.mainSite": "Site principal",
  "footer.privacy": "Politique de confidentialité",
  "footer.terms": "Conditions d'utilisation",
  "footer.disclaimerTitle": "Avertissement",
  "footer.rights": "Tous droits réservés.",
};